import { useEffect, useState } from "react";
import { decryptData, defaulUrl } from "../../components/const";
import Swal from "sweetalert2";
import { use } from "react";
import UseFetch from "../../components/UseFetch";

const CommandeValide = () => {

    const [erreur, setErreur] = useState(null);

    const [searchClient, setSearchClient] = useState("");
    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");

    const idmagasin = decryptData("user_profile").idmagasin;
    const { data: commandes, isloading, error, refresh } = UseFetch(`cmd-valide/${idmagasin}`);


    const commandesFiltrees = commandes?.filter((cmd) => {
        const clientStr = cmd.client.client.toLowerCase() + " " + cmd.client.telephone.toLowerCase();
        if (!clientStr.includes(searchClient.toLowerCase())) return false;

        if (dateDebut) {
            const cmdDate = new Date(cmd.created_at);
            const deb = new Date(dateDebut);
            if (cmdDate.setHours(0, 0, 0, 0) < deb.setHours(0, 0, 0, 0)) return false;
        }
        if (dateFin) {
            const cmdDate = new Date(cmd.created_at);
            const fin = new Date(dateFin);
            if (cmdDate.setHours(0, 0, 0, 0) > fin.setHours(0, 0, 0, 0)) return false;
        }
        return true;
    });


    // Fonction pour encaisser une commande
    const encaisserCommande = async (cmdId) => {
        const { value: formValues } = await Swal.fire({
            title: 'Encaissement',
            html:
                `
                <div class="form-group">
                <input id="swal-montant" type="number" min="0" step="1000" class="swal2-input" placeholder="Montant encaissé (GNF)">
                <div>
                <div class="form-group w-50 m-auto" hidden>
                 <select id="swal-mode" class="  form-select my-2">
                    
                    <option value="client">Client</option>
                    <option value="Compte client">Compte Client</option>
                 </select>
                <div> `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Valider',
            cancelButtonText: 'Annuler',
            preConfirm: () => {
                const montant = parseFloat(document.getElementById('swal-montant').value);
                const mode_paye = document.getElementById('swal-mode').value ?? 'Client';

                if (!montant || montant <= 0) {
                    Swal.showValidationMessage('Veuillez saisir un montant valide (> 0)');
                    return false;
                }
                if (!mode_paye) {
                    Swal.showValidationMessage('Veuillez sélectionner un mode de paiement');
                    return false;
                }

                return { montant, mode_paye };
            }
        });

        if (!formValues) return; // L'utilisateur a annulé

        const { montant, mode_paye } = formValues;

        try {
            const response = await fetch(`${defaulUrl}admin-site/payer-cmd/${cmdId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
                },
                body: JSON.stringify({ montant, mode_paye })
            });

            const data = await response.json();
            if (!response.ok) throw new Error("Erreur lors de l'encaissement " + data.message);
            Swal.fire('Succès', data.message, 'success');
            refresh(); // Rafraîchir les données après l'encaissement

        } catch (error) {
            Swal.fire('Erreur', error.message, 'error');
        }
    };

    // fonction pour livrer une commande, il ny a pas de champ, il faut juste demande la confirmation
    // et mettre à jour la commande en base de données
    const livrerCommande = async (cmdId) => {
        const confirmation = await Swal.fire({
            title: 'Confirmation',
            text: "Êtes-vous sûr de vouloir valider la livraison de cette commande ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, livrer',
            cancelButtonText: 'Non, annuler'
        });

        if (!confirmation.isConfirmed) return;

        try {
            const response = await fetch(`${defaulUrl}admin-site/livrer-cmd/${cmdId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
                }
            });

            const data = await response.json();
            console.log(data);
            if (!response.ok) throw new Error("Erreur lors de la livraison " + data.message);
            Swal.fire('Succès', data.message, 'success');
            refresh(); // Rafraîchir les données après la livraison

        } catch (error) {
            Swal.fire('Erreur', error.message, 'error');
        }

    }

    const totalfacture = commandesFiltrees?.reduce((previous, current) => previous + parseFloat(current.montant_net), 0) || 0;
    const totalPaye = commandesFiltrees?.reduce((total, cmd) => total + parseFloat(cmd.paye), 0) || 0;
    const totalImpaye = totalfacture - totalPaye;


    if (erreur) return <div className="text-danger text-center">{erreur}</div>;

    return (
        <div className="container mt-3">

            {isloading && <div className="text-center py-2"><div className="loader"></div></div>}
            <h4 className="text-primary mb-3">Commandes validées</h4>



            <div className="mb-3 row g-3 align-items-center">
                <div className="col-sm-4">
                    <input
                        type="text"
                        placeholder="Rechercher client..."
                        className="form-control"
                        value={searchClient}
                        onChange={(e) => setSearchClient(e.target.value)}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        type="date"
                        className="form-control"
                        value={dateDebut}
                        onChange={(e) => setDateDebut(e.target.value)}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        type="date"
                        className="form-control"
                        value={dateFin}
                        onChange={(e) => setDateFin(e.target.value)}
                    />
                </div>
            </div>

            {commandesFiltrees?.length === 0 && (
                <p className="text-muted">Aucune commande trouvée pour ces filtres.</p>
            )}

            <div className="row  mb-3 row-cols-1 row-cols-md-3 g-3">
                <div className="col">
                    <div className="card h-100 bg-info text-white p-3 border-0">
                        <h6>Montant Total</h6>
                        {totalfacture.toLocaleString()} GNF
                    </div>
                </div>
                <div className="col">
                    <div className="card h-100 bg-success text-white p-3 border-0">
                        <h6>Montant Payé</h6>
                        {totalPaye.toLocaleString()} GNF
                    </div>
                </div>
                <div className="col">
                    <div className="card h-100 bg-danger text-white p-3 border-0">
                        <h6>Montant impayé</h6>
                        {totalImpaye.toLocaleString()} GNF
                    </div>
                </div>
            </div>

            <div className="accordion" id="accordionCommandes">
                {commandesFiltrees?.map((cmd) => (
                    <div key={cmd.id} className="accordion-item my-2">
                        <h2 className="accordion-header" id={`heading${cmd.id}`}>
                            <button
                                className="accordion-button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${cmd.id}`}
                                aria-expanded="false"
                                aria-controls={`collapse${cmd.id}`}
                            >
                                {cmd.no_cmd} • Client : {cmd.client.client} ({cmd.client.telephone}) - <span className="text-secondary">{new Date(cmd.created_at).toLocaleDateString()}</span>
                            </button>
                        </h2>
                        <div
                            id={`collapse${cmd.id}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`heading${cmd.id}`}
                            data-bs-parent="#accordionCommandes"
                        >
                            <div className="accordion-body">
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Produit</th>
                                                <th>Conteneur</th>
                                                <th>Qté commandée</th>
                                                <th>Prix unitaire (GNF)</th>
                                                <th>Qté livrée</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cmd.details.map((detail, i) => (
                                                <tr key={i}>
                                                    <td>{detail.produit.produit}</td>
                                                    <td>{detail.conteneur}</td>
                                                    <td>{detail.quantite_cmd}</td>
                                                    <td>{detail.pvu.toLocaleString()}</td>
                                                    <td>{detail.quantite_livre || 0}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="card-footer mt-3">
                                    <div className="row">
                                        <div className="col-md-3"><strong>Total :</strong> {cmd.montant_total.toLocaleString()} GNF</div>
                                        <div className="col-md-2"><strong>Remise :</strong> {cmd.remise.toLocaleString()} GNF</div>
                                        <div className="col-md-3"><strong>Net :</strong> {(cmd.montant_net).toLocaleString()} GNF</div>
                                        <div className="col-md-2"><strong>Payé :</strong> {cmd.paye.toLocaleString()} GNF</div>
                                        <div className="col-md-2 text-danger"><strong>Impayé :</strong> {(cmd.montant_net - cmd.paye).toLocaleString()} GNF</div>
                                    </div>
                                </div>

                                <div className="mt-3 d-flex justify-content-end gap-2">

                                    {(parseFloat(cmd.paye) < parseFloat(cmd.montant_net)) ? < button className="btn btn-outline-primary btn-sm" onClick={() => encaisserCommande(cmd.id)}>
                                        Encaisser
                                    </button> : <span className="badge bg-success">Payée</span>}
                                    {cmd.statut_livraison == 'livrée' ? <span className="badge bg-success">{cmd.statut_livraison}</span> : <button className="btn btn-outline-success btn-sm" onClick={() => livrerCommande(cmd.id)}>
                                        Valider la livraison
                                    </button>}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div >
    );
};

export default CommandeValide;
